import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" TeslaSCADA Cloud ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("TeslaSCADA Cloud")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isItReallyMobile())
      ? (_openBlock(), _createBlock(_component_q_layout, {
          key: 0,
          view: "hHh lpR fFf",
          class: "shadow-2 rounded-borders"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_header, {
              reveal: "",
              elevated: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar, null, {
                  default: _withCtx(() => [
                    (_ctx.currentUser  && _ctx.notAuthenticate)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          dense: "",
                          flat: "",
                          round: "",
                          icon: "menu",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleLeftDrawer()))
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_toolbar_title, null, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    (_ctx.currentUser  && _ctx.notAuthenticate)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          flat: "",
                          class: "q-mr-none q-pa-none",
                          icon: "logout",
                          onClick: _ctx.logOut
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (!_ctx.currentUser && _ctx.notAuthenticate)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 2,
                          flat: "",
                          class: "q-mr-sm q-pa-none",
                          label: _ctx.t('maintoolbar.signup'),
                          to: "/register"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (!_ctx.currentUser && _ctx.notAuthenticate)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 3,
                          flat: "",
                          class: "q-mr-none q-pa-none",
                          label: _ctx.t('maintoolbar.login'),
                          to: "/login"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_drawer, {
              modelValue: _ctx.leftDrawerOpen,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.leftDrawerOpen) = $event)),
              side: "left",
              width: 200,
              breakpoint: 500,
              bordered: "",
              overlay: "",
              elevated: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_scroll_area, { class: "fit" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_list, null, {
                      default: _withCtx(() => [
                        (_ctx.showHomeBoard)
                          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              key: 0,
                              clickable: "",
                              to: "/home"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "widgets",
                                      color: "primary"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('tagsettings.Cards')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_separator)
                              ]),
                              _: 1
                            }, 512)), [
                              [_directive_ripple]
                            ])
                          : _createCommentVNode("", true),
                        (_ctx.showScreens)
                          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              key: 1,
                              clickable: "",
                              to: "/screens"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "picture_in_picture",
                                      color: "primary"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('maintoolbar.screens')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_separator)
                              ]),
                              _: 1
                            }, 512)), [
                              [_directive_ripple]
                            ])
                          : _createCommentVNode("", true),
                        (_ctx.showAdminBoard)
                          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              key: 2,
                              clickable: "",
                              to: "/admin"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "home",
                                      color: "primary"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('maintoolbar.adminboard')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_separator)
                              ]),
                              _: 1
                            }, 512)), [
                              [_directive_ripple]
                            ])
                          : _createCommentVNode("", true),
                        (_ctx.showAdminBoard)
                          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              key: 3,
                              clickable: "",
                              to: "/sessions"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "table",
                                      color: "primary"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('maintoolbar.adminsessions')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_separator)
                              ]),
                              _: 1
                            }, 512)), [
                              [_directive_ripple]
                            ])
                          : _createCommentVNode("", true),
                        (_ctx.currentUser && _ctx.showProfile)
                          ? _withDirectives((_openBlock(), _createBlock(_component_q_expansion_item, {
                              key: 4,
                              "content-inset-level": 0.3,
                              clickable: "",
                              icon: "settings",
                              label: _ctx.t('usersettings.settings'),
                              "default-opened": ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                                  return (_openBlock(), _createBlock(_component_q_item, {
                                    clickable: "",
                                    key: option.name,
                                    to: {name:'usersettingsmobile', params: {'name': option.name}}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { avatar: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_icon, {
                                            name: option.icon,
                                            color: "primary"
                                          }, null, 8, ["name"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_q_item_section, { avatar: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t(option.title)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["content-inset-level", "label"])), [
                              [_directive_ripple]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_page_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.isItReallyMobile())
      ? (_openBlock(), _createBlock(_component_q_layout, {
          key: 1,
          class: "shadow-2 rounded-borders"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_header, { elevated: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, { class: "title" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: "/",
                          class: "text-white text-bold",
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.showHomeBoard)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          flat: "",
                          label: _ctx.t('tagsettings.Cards'),
                          icon: "widgets",
                          to: "/home"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.showScreens)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          flat: "",
                          label: _ctx.t('maintoolbar.screens'),
                          icon: "picture_in_picture",
                          to: "/screens"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.showAdminBoard)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 2,
                          flat: "",
                          label: _ctx.t('maintoolbar.adminboard'),
                          icon: "home",
                          to: "/admin"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.showAdminBoard)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 3,
                          flat: "",
                          label: _ctx.t('maintoolbar.adminsessions'),
                          icon: "table",
                          to: "/sessions"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_btn_group, {
                      class: "userbuttons",
                      flat: ""
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.currentUser && _ctx.notAuthenticate)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              flat: "",
                              label: _ctx.t('maintoolbar.signup'),
                              icon: "input",
                              to: "/register"
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (!_ctx.currentUser && _ctx.notAuthenticate)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 1,
                              flat: "",
                              label: _ctx.t('maintoolbar.login'),
                              icon: "login",
                              to: "/login"
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (_ctx.currentUser && _ctx.showProfile)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 2,
                              flat: "",
                              icon: "settings",
                              label: _ctx.t('usersettings.settings'),
                              to: "/usersettings"
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (_ctx.currentUser  && _ctx.notAuthenticate)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 3,
                              flat: "",
                              icon: "logout",
                              label: _ctx.t('maintoolbar.logout'),
                              onClick: _ctx.logOut
                            }, null, 8, ["label", "onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_page_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}